/**
 * Error utility functions
 */

/**
 * Check if an error message indicates a storage limit issue
 */
export function isStorageLimitError(error: string | null | undefined): boolean {
  return error?.toLowerCase().includes('storage') ?? false;
}
